// extracted by mini-css-extract-plugin
module.exports = {"label":"IndustryLabel_label__1NIZs","selectedLabel":"IndustryLabel_selectedLabel__3lzlT","lockedLabel":"IndustryLabel_lockedLabel__3yD8c","icon":"IndustryLabel_icon__2JvYZ"};